import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {getStudyCoordinatorRequest, IState} from 'study_coordinator/store'
import {IProps} from './subject-form-base'

type StateProps = Pick<IProps,
  'isFetching'
  | 'ageOptions'
  | 'deviceTypeOptions'
>

type DispatchProps = Pick<IProps, 'onMount'>

type OwnProps = Pick<IProps,
  'subjectIdentifierAllowedInput'
  | 'subjectIdentifierDisabled'
>

const mapStateToProps = (state: IState): StateProps => {
  const {institution, isFetching} = state.studyCoordinator
  if (!institution) {
    return {
      isFetching,
      ageOptions: [],
      deviceTypeOptions: [],
    }
  }
  return {
    isFetching,
    ageOptions: institution.allowedAges,
    deviceTypeOptions: institution.allowedDeviceTypes,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<void>): DispatchProps => ({
  onMount: () => dispatch(getStudyCoordinatorRequest()),
})

export const connectSubjectForm = (Component: React.ComponentType<IProps>) => (
  connect<StateProps, DispatchProps, OwnProps, IState>(
    mapStateToProps,
    mapDispatchToProps,
  )(Component)
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/subjects/subject-form/subject-form-connect.tsx